module.exports = "//static.hsappstatic.net/FileManagerImages/static-1.31227/images/ai-styles/cinematic.jpg"